import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseinfo: {},
    education: {
      studyExp: [],
      train: []
    },
    workExp: {
      workInfo: [],
      otherInfo: {},
      tags: []
    },
    signInfo: {},
    applicantInfo: [],
    inviteCode: {
      
    }
  },
  mutations: {
    SET_BASE_INFO: (state, data) => {
      state.baseinfo = data
    },
    SET_EDUTION_INFO: (state, data) => {
      state.education = data
    },
    SET_WORKEXP_INFO: (state, data) => {
      state.workExp = data
    },
    SET_SIGN_INVITECODE: (state, data) => {
      state.inviteCode = data
    },
    SET_SIGN_INFO: (state, data) => {
      state.signInfo = data
    },
    GET_ALL_INFO: (state) => {
      state.ApplicantInfo = []
      state.ApplicantInfo.push(state.baseinfo, state.education, state.workExp, state.signInfo);
    },
  },
  actions: {
  },
  modules: {
  }
})
